
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import moment from 'moment-timezone';

import PopupWithClose from '@/components/popup/popup-with-close.vue';
import PreviewController from '@/components/common/preview-controller.vue';

import { SET_INSTANT_FORM } from '@/store/types/index';
import {
  InstantFormItem,
  defaultInstantFormItem,
  leadAdsEditorIframeSource,
  LeadAdsEditorIframePayloadType,
  mobileLiteIframeSource,
  leadAdsFormPreviewDomain
} from '@/const/leadAds';
import { CHART_FORMAT_DAILY_TIME } from '@/utils/dateUtil';
import * as tool from 'src/utils/tool';

@Component({
  name: 'LeadFormPreviewPopup',
  components: {
    PopupWithClose,
    PreviewController
  }
})
export default class LeadFormPreviewPopup extends Vue {
  @Prop({ default: () => defaultInstantFormItem, type: Object })
  readonly value!: InstantFormItem
  @Prop({ type: Boolean, default: true }) showLeftBtn!: boolean
  @Prop({ type: Boolean, default: true }) showSelect!: boolean
  @Prop({ type: String, default: '80%' }) height!: string

  @Mutation(SET_INSTANT_FORM, { namespace: 'creative/create' })
  setInstantForm: (instantForm: InstantFormItem) => void

  $refs: {
    previewIframeRef: any;
  }
  iframeLoading = true
  curPage = 1
  totalPage = 1
  loadingTimer = 0

  @Watch('value', { immediate: true })
  onValueChange(newVal: InstantFormItem | null) {
    if (newVal) {
      this.iframeLoading = true;
      this.curPage = 1;
      this.totalPage = 1;
      this.$nextTick(() => {
        this.setupPreviewIframe();
      });
    } else {
      this.resetPreviewIframe();
      clearTimeout(this.loadingTimer);
    }
  }
  get title(): string {
    return this.value?.title || '';
  }

  get iframeSrc() {
    const previewUrl = this.value?.preview_url || '';
    return (
      previewUrl &&
        tool.addJsonQueryToUrl(previewUrl, {
          source: 'mobile_lite'
        }) || ''
    );
  }

  get formTime() {
    return (
      this.$t('Last Update: ') +
      moment(this.value?.update_time).format(CHART_FORMAT_DAILY_TIME)
    );
  }

  get pageInfo() {
    return `${this.curPage}/${this.totalPage}`;
  }

  handleSelect() {
    this.handleClose();
    this.$emit('select', this.value);
  }

  handleClose() {
    this.$emit('input', defaultInstantFormItem);
  }

  handleClickRight() {
    this.handleClose();
    this.$emit('click-right');
  }

  handleControlPage(go: number) {
    this.curPage += go;
    this.postMessageToIframe({
      type: LeadAdsEditorIframePayloadType.PAGINATION,
      action: go > 0 ? 'next' : 'prev'
    });
  }

  previewIframeMessageHandler(event: MessageEvent) {
    if (event.origin !== leadAdsFormPreviewDomain) {
      return;
    }
    const { source = '', payload = {} } = event.data || {};
    if (source !== leadAdsEditorIframeSource) {
      return;
    }
    if (payload.type === LeadAdsEditorIframePayloadType.PAGINATION) {
      this.totalPage = payload.total;
    }
  }

  setupPreviewIframe = () => {
    window.addEventListener('message', this.previewIframeMessageHandler);
  }

  resetPreviewIframe() {
    window.removeEventListener('message', this.previewIframeMessageHandler);
  }

  postMessageToIframe(
    payload: {
      type: LeadAdsEditorIframePayloadType;
    } & Record<string, number | string>
  ) {
    this.$refs.previewIframeRef?.contentWindow?.postMessage(
      {
        source: mobileLiteIframeSource,
        payload
      },
      leadAdsFormPreviewDomain
    );
  }
}
